import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Alert } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setRisqueDetailsData } from '../../../redux/risqueDetailsDataSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/roles/updateRoleName.css';

export const UpdateRisque = ({ updateRisqueOpen, setUpdateRisqueOpen }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState(null);
    const risqueDetailsData = useSelector((state) => state.RisqueDetailsData);

    const formik = useFormik({
        initialValues: {
            name: risqueDetailsData?.name || '',
            description: risqueDetailsData?.description || '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('isRequired')),
            description: Yup.string().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`risk/${risqueDetailsData.id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setRisqueDetailsData({ ...risqueDetailsData, name: response.data.name, description: response.data.description }));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier le nom et la description de la risque" }));
                    setUpdateRisqueOpen(false);
                }
            } catch (error) {
                setErrMsg(error?.response?.data?.message || error.message || 'Erreur lors de la modification de la risque');
                console.error('Error updating risque :', error);
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

    return (
        <Dialog open={updateRisqueOpen} fullWidth>
            <Box onClick={() => setUpdateRisqueOpen(false)} className='updateRoleName_icon_text'>
                <Typography className='updateRoleName_title'>{t("Modifier le nom et la description de la risque")}</Typography>
                <Iconify icon={"material-symbols:close"} className='updateRoleName_close_icon' />
            </Box>
            {errMsg && <Alert key={errMsg} severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateRoleName_dialog_content'>
                    <Box className="updateRoleName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateRoleNameInputTitle">{t('Nom')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.name}
                            className='updateRoleName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateRoleName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateRoleNameInputTitle">{t('Description')} (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.description}
                            className='updateRoleName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="description"
                            error={touched.description && Boolean(errors.description)}
                            helperText={touched.description && errors.description}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='updateRoleName_dialog_actions'>
                    <Button className='updateRoleName_button_annuler' onClick={() => setUpdateRisqueOpen(false)}>{t('Annuler')}</Button>
                    <Button className='updateRoleName_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};